import React, {useEffect} from 'react';
import Button from '../../../../components/common/ui-components/input/Button';
import UITextField from '../../../../components/common/ui-components/input/UITextField';
import styles from './form.module.scss';
import { SendOTP, VerifyOTP } from '../../../../api/salespro';
import Image from '../../../../components/common/Image'
import { cleverTapTrigger } from '../../../../tracking/segment';
import ReCAPTCHA from 'react-google-recaptcha';
import { getCachedRecaptchaToken, isRecaptchaReady } from '../../../../utils/recaptcha';
import Config from '../../../../config';


const Form = (props) => {
    const [phoneValid, setPhoneValid] = React.useState<boolean | false>(false)
    const [phoneValue, setPhoneValue] = React.useState<string>("")
    const [phoneError, setPhoneError] = React.useState<string | null>(null)
    const [buttonEnabled, toggleButton] = React.useState<boolean>(false)
    const [otpSent, setOtpStatus] = React.useState<boolean>(false)
    const [otpCode, setOtpCode] = React.useState<string>('')
    const [otpError, setOtpError] = React.useState<string | null>(null)
    const [otpBtnMessage, setOtpBtnMessage] = React.useState<any>()
    const [otpVerified, setOtpVerified] = React.useState<boolean>(false)
    const [otpAttempts, incrementOtpAttempts] = React.useState<number>(0)
    const [resend, enableResend] = React.useState<boolean>(false)
    const [loading, setLoadingState] = React.useState<boolean>(false)
    const [timer, setTimer] = React.useState<any>(null)
    const [count, setCount] = React.useState<number>(0)
    const [resenttimer, setResentTimer] = React.useState<any>(null)
    const [errorName, setErrorName] = React.useState<string>("");
    const [name, setName] = React.useState<string>("");
    const [validName, setValidName] = React.useState<boolean>(false)
    const [scrollPosition, setScrollPosition] = React.useState(0);
    const [isCaptchaRequired, setIsCaptchaRequired] = React.useState<boolean>(false);
    const [isCaptchaVerified, setIsCaptchaVerified] = React.useState<boolean>(false);
    const [captchaV2Token, setCaptchaV2Token] = React.useState<string>("");
    const [sessionCaptchaToken, setSessionCaptchaToken] = React.useState<string>("");
    const recaptchaV2Key = Config.RECAPTCHA_V2_SITE_KEY;
    const formStart = 4050;
    const getCaptchaToken = async (action: string): Promise<string> => {
      return getCachedRecaptchaToken(action);
    };
    const formEnd = 4600;

    const handleScroll = () => {

      setScrollPosition(window.scrollY || window.pageYOffset);
    };
  
    useEffect(() => {
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);

    useEffect(() => {
      if (scrollPosition < formStart || scrollPosition > formEnd) {
        const a :any =document.querySelector(`input#form`)
        a?.blur()
      }
    }, [scrollPosition]);


    const onPhoneChange = (e: { target: { name: string, value: string } }) => {
        let phone = e.target.value.trim().replace(/\D/g, '')
        setOtpCode('')
        setOtpBtnMessage(null)
        setOtpVerified(false)
        setOtpStatus(false)
        setPhoneError(null)
        setPhoneValue(phone)
        setOtpError(null)
        if (phone && phone.length == 10) {
          setPhoneError(null)
          setPhoneValid(true)
          toggleButton(true)
        } else {
          setPhoneValid(false)
          toggleButton(false)
        }
      }

    const validatePhone = (e: { target: { name: string, value: string } }) => {
        let phone = e.target.value.trim().replace(/\D/g, '')
        let isValid = false;
        if (!phone) {
          setPhoneValid(false)
          toggleButton(false)
          setOtpStatus(false)
          setOtpBtnMessage(null)
          setPhoneError('Required field')
        } else if (phone.length > 10) {
          setPhoneError('Phone number cannot exceed 10 digits')
          setPhoneValid(false)
          setOtpStatus(false)
          setOtpBtnMessage(null)
          toggleButton(false)
        } else if (phone.length < 10) {
          setPhoneValid(false)
          toggleButton(false)
          setOtpStatus(false)
          setOtpBtnMessage(null)
          setPhoneError('Please enter valid phone number')
        } else {
          setPhoneError(null)
          setPhoneValid(true)
          toggleButton(true)
          isValid = true
        }
        setPhoneValue(phone)
        return isValid
      }
    
    const handleEnterPhone = (e) => {
        let a;
        if (e.key) {
          a = e.key
        }
        else {
          a = e.which || e.keyCode
        }
        if (a === "Enter" || a === 13) {
          sendOtp()
          if (document.querySelector(`input#otp`)) {
            const a: any = document.querySelector(`input#otp`);
            setTimeout(() => { a.focus() }, 500)
          }
        }
      }

    const setCountdownTimer = (countFrom) => {
      let counter = countFrom
      if (timer) {
          clearInterval(timer)
          setTimer(null)
      }
      if (resenttimer) {
          clearTimeout(resenttimer)
      }
      setCount(counter)

      if (otpAttempts < 3) {
          let resentCounter = setTimeout(() => {
          enableResend(true)
          }, countFrom * 1000)
          setResentTimer(resentCounter)
      }
      let countDownTimer = setInterval(function () {
          counter = counter - 1
          setCount(counter)
          if (!(counter > 0)) {
          clearInterval(countDownTimer)
          setTimer(null)
          }
      }, 1000)
      setTimer(countDownTimer)
    }

    const resetCaptchaState = () => {
      setIsCaptchaRequired(false);
      setIsCaptchaVerified(false);
      setCaptchaV2Token("");
    };

    const handleCaptchaRequired = () => {
      setIsCaptchaRequired(true);
      setIsCaptchaVerified(false);
      setCaptchaV2Token("");
      setPhoneError("Please complete the CAPTCHA to continue.");
    };

    const sendOtp = async () => {
      if (!otpSent && phoneValid && phoneValue !== '') {
          if (isCaptchaRequired && !isCaptchaVerified) {
            setPhoneError("Please complete the CAPTCHA to continue.");
            return;
          }
          if (!isRecaptchaReady() && !captchaV2Token) {
            setPhoneError("CAPTCHA not ready. Please refresh the page again.");
            return;
          }
          setLoadingState(true)
          enableResend(false)
          const captchaToken = captchaV2Token || await getCaptchaToken('otp');
          const captchaTokenType = captchaV2Token ? 'v2' : 'v3';
          if (!captchaToken) {
            setLoadingState(false)
            setPhoneError("CAPTCHA not ready. Please refresh the page again.");
            return;
          }
          SendOTP({
          application: 'website',
          data: {
              phone: phoneValue,
              type: 'salespro-webpage',
              template: 'onsite_generic_otp', 
              force: true,
              captcha_token: captchaToken,
              captcha_token_type: captchaTokenType,
          }
          })
          .then((res: any) => {
              setLoadingState(false)
              if (res.data.status) {
              setSessionCaptchaToken(captchaToken);
              resetCaptchaState();
              incrementOtpAttempts(1);
              setOtpStatus(true)
              const enterOTP: any = document.querySelector(`#OTP`)
              enterOTP?.focus()
              setOtpBtnMessage({
                  type: 'success',
                  message: 'OTP Sent'
              })
              toggleButton(false)
              setCountdownTimer(30)
              } else {
              setOtpError(res.data.message)
              }
          })
          .catch((err) => {
              setLoadingState(false)
              if (!(err instanceof Response)) {
                console.log(err)
                return;
              }
              err.json().then((res:any) => {
                const errorCodes = res?.error_code;
                const isAuthFailed = errorCodes.includes("recaptcha_verification_failed");
                const isAdditionalAuthRequired = errorCodes.includes("additional_authentication_required");
                if (isAuthFailed) {
                  setPhoneError("Please refresh the page. If not, the page will refresh automatically in 10 seconds.");
                  setTimeout(() => {
                    window.location.reload();
                  }, 10000);
                  return;
                }
                if (isAdditionalAuthRequired) {
                  handleCaptchaRequired();
                  return;
                }
              })
              console.log(err)
          })
      } else {
          return false
      }
    }

    const handleOtpBlur = (e: any) => {
        if (e.target.value.trim().replace(/\D/g, '').length !== 4) {
          setOtpError('OTP must be 4 digits long')
        }
      }

    const checkOtpLength = (e: { target: { name: string, value: string } }) => {
        let otp = e.target.value.trim().replace(/\D/g, '')
        if (otp.length<5){
            setOtpCode(e.target.value.trim().replace(/\D/g, ''))
            setOtpError(null)
            if(otp.length===4){
            toggleButton(true)
            }else{
            toggleButton(false)
            }
        }
    }

    const handleEnterOtp = (e) => {
        let a;
        if (e.key) {
          a = e.key
        }
        else {
          a = e.which || e.keyCode
        }
        if (a === "Enter" || a === 13) {
            validateOtp()
        }
      }

    const validateOtp = () => {
      let otp = otpCode
      if(!loading && otp.length === 4) {
        setLoadingState(true)
        VerifyOTP({
        application: 'website',
        data:{
            name: name,
            phone:phoneValue,
            type: 'salespro-webpage',
            otp: otp,
        }
        })
        .then((res:any) => {
        if('is_valid' in res.data && res.data.is_valid){
            if('is_authenticate' in res.data){
                setOtpVerified(true)
            }else{
                setLoadingState(false)
            if(res.response.status==200) {
                cleverTapTrigger("Get In Touch Details Submitted", {'Name' : name, 'Phone' : phoneValue})
                setOtpVerified(true)
            }}
            }else{
            setOtpError("Incorrect OTP")
            }
            setLoadingState(false)
        }).catch((err:any) => {
            setLoadingState(false)
            console.log(err);
          })
        }
    }

    const resendOtp = async (e:any) => {
      e.preventDefault();
      enableResend(false)
      if(phoneValid && phoneValue !== '' && otpAttempts <= 3) {
        if (!sessionCaptchaToken) {
          setPhoneError("Please try again.");
          return;
        }
        const captchaToken = sessionCaptchaToken;
        const captchaTokenType = 'session_verified';
        if (!captchaToken) {
          setPhoneError("CAPTCHA not ready. Please refresh the page again.");
          return;
        }
        SendOTP({
          application: 'website',
          data:{
            phone:phoneValue,
            type: 'salespro-webpage',
            template: 'onsite_generic_otp',
            captcha_token: captchaToken,
            captcha_token_type: captchaTokenType,
          }
        }).then((res:any) => {
          if(res.data.status)  {
            resetCaptchaState();
            incrementOtpAttempts(otpAttempts + 1);
            setOtpStatus(true)
            const enterOTP: any = document.querySelector(`#OTP`)
            enterOTP?.focus()
            setOtpBtnMessage({
              type: 'success',
              message: 'OTP Sent'
            })
            toggleButton(false)
            setCountdownTimer(30)
          } else {
            setOtpBtnMessage({
              type: 'error',
              message: res.data.message
            })
          }
        })
        .catch((err) => {
          if (!(err instanceof Response)) {
            console.log(err)
            return;
          }
          err.json().then((res:any) => {
            const errorCodes = res?.error_code;
            const isAuthFailed = errorCodes.includes("recaptcha_verification_failed");
            const isAdditionalAuthRequired = errorCodes.includes("additional_authentication_required");
            if (isAuthFailed) {
              setPhoneError("Please refresh the page. If not, the page will refresh automatically in 10 seconds.");
              setTimeout(() => {
                window.location.reload();
              }, 10000);
              return;
            }
            if (isAdditionalAuthRequired) {
              handleCaptchaRequired();
              return;
            }
          })
          console.log(err)
        })
      }
    }

    return (
    <>
        <div className={`${styles.parent_container} app-section`} >
            <div className={styles.header} id='getInTouch' >
                <div className={`app-section__title em ${styles.heading}`}>Get in Touch</div>
                <div className={styles.description}>Our executive will get back to you within 24 hours</div>
            </div>
            <div className={styles.form_block}>
                <div className={styles.contact_image}>
                    <Image src={'/static/images/salespro/contact_us.webp' || ''} alt={"contact-us"} height="310" width="436" />
                </div>
                {
                    !otpVerified && 
                    <div className={styles.form}>
                        <UITextField 
                            className={`inputField ${styles.text_field}`} 
                            placeholder='Enter your full name' 
                            label='Name' 
                            id='form'
                            value={name}
                            onChange={(e: { target: { name: string; value: string } }) => {
                                setErrorName("");
                                const re = /^[A-Za-z ]+$/;
                                if (e.target.value === "" || re.test(e.target.value)) {
                                  setName(e.target.value);
                                  if (e.target.value.length !== 0){
                                    setValidName(true)
                                  }
                                  else{
                                    setValidName(false)
                                  }
                                } else {
                                setErrorName("Enter Only Alphabet");
                              }
                            }}
                            onBlur={(e) => {
                              if (e.target.value.length === 0) {
                                setErrorName("Required Field");
                              }
                            }}
                            propsError={errorName}
                            maxLength={50}
                            isRequired={true}
                        />
                        <UITextField 
                            className={`inputField ${styles.text_field} ${styles.mobile_field}`} 
                            placeholder='Enter your 10 digit mobile number' 
                            label='Verify Mobile Number' 
                            value={phoneValue !== null ? phoneValue.replace(/[^0-9]/gi, '') : ''}
                            hasError={phoneError !== null} propsError={phoneError !== null ? phoneError : undefined}
                            isRequired={true} type="tel"
                            onChange={(e: { target: { name: string, value: string } }) => onPhoneChange(e)}
                            onBlur={(e: any) => { validatePhone(e) }}
                            onKeyPress={(e) => { handleEnterPhone(e) }}
                            maxLength={10}
                            id="form"
                        />
                        {isCaptchaRequired && recaptchaV2Key && (
                          <div className={styles.captcha}>
                            <ReCAPTCHA
                              sitekey={recaptchaV2Key}
                              enterprise={false}
                              onChange={(token) => {
                                setCaptchaV2Token(token || "");
                                setIsCaptchaVerified(Boolean(token));
                                setPhoneError("");
                              }}
                              onExpired={() => {
                                setCaptchaV2Token("");
                                setIsCaptchaVerified(false);
                              }}
                              onErrored={() => {
                                setPhoneError("Verification failed to load. Please refresh the page and try again.");
                              }}
                            />
                          </div>
                        )}
                        {otpSent ?
                        <div>
                            <UITextField 
                                id='OTP'
                                className={`inputField ${styles.text_field} ${styles.otp_field}`} 
                                placeholder='Enter 4 digit OTP' 
                                label='Enter OTP'
                                isDisabled={!otpSent || otpVerified}
                                value={otpCode !== null ? otpCode.replace(/[^0-9]/gi, '') : ''}
                                type="tel"
                                onChange={(e: { target: { name: string, value: string } }) => checkOtpLength(e)}
                                hasError={otpSent && otpError !== null}
                                propsError={otpError !== null ? otpError : undefined}
                                isRequired={true}
                                onBlur={(e: any) => { handleOtpBlur(e) }}
                                onKeyPress={(e) => { handleEnterOtp(e) }}
                            />
                        
                        {
                            <div className={styles.validation_section}>
                              <div className={styles.validation_section_cta}>
                                <Button disabled={otpVerified ? true : !(buttonEnabled && validName)} className={styles.cart_btn} text={'Verify OTP'} onClick={(e: React.MouseEvent) => { validateOtp() }} />
                              </div>
                              <div className={styles.validation_section_info}>
                                {!otpVerified &&
                                    (
                                        otpAttempts <= 3 && !(otpBtnMessage && otpBtnMessage.type == 'error') ?
                                        (
                                        !resend ? (
                                            <>
                                            {otpBtnMessage && <p className={otpBtnMessage.type == 'success' ? styles.resend_otp__success : styles.resend_otp__error}>{otpBtnMessage.message}</p>}
                                            {count > 0 && <p className={styles.resend}>Resend OTP after {count} seconds</p>}
                                            </>
                                        )
                                            :
                                            <a href="#" className={styles.resend_otp} onClick={(e: any) => {resendOtp(e)}}>Resend OTP</a>
                                        )
                                        :
                                        <>
                                        {otpBtnMessage && <p className={otpBtnMessage.type == 'success' ? styles.resend_otp__success : styles.resend_otp__error}>{otpBtnMessage.message}</p>}
                                        </>
                                    )
                                }
                              </div>
                            </div>
                        }
                        </div>
                        :
                        <div className={styles.send_otp}>
                          <Button
                            disabled={
                              otpVerified ? true :
                              !(buttonEnabled && validName) ||
                              (isCaptchaRequired && !isCaptchaVerified) ||
                              (!isRecaptchaReady() && !captchaV2Token)
                            }
                            className={styles.cart_btn}
                            text={'Send OTP'}
                            onClick={(e: React.MouseEvent) => sendOtp()}
                          />
                        </div>
                        }
                    </div>
                }
                {
                    otpVerified &&
                    <div className={styles.verified}>
                        <div className={styles.verified_image}>
                            <Image src={'/static/images/salespro/verified.svg' || ''} alt={"verified"} height="48" width="48" />
                        </div>
                        <div className={styles.verified_text}>OTP Verified Successfully</div>
                        <div className={styles.verified_title}>Thank you for showing interest!</div>
                        <div className={styles.verified_message}>Our executive will get back to you shortly</div>
                    </div>
                }
            </div>
        </div>
    </>
    );
}


export default Form;
